import { render, staticRenderFns } from "./findpwd.vue?vue&type=template&id=731a05ec&scoped=true"
import script from "./findpwd.vue?vue&type=script&lang=js"
export * from "./findpwd.vue?vue&type=script&lang=js"
import style0 from "./findpwd.vue?vue&type=style&index=0&id=731a05ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731a05ec",
  null
  
)

export default component.exports